const formNames = {
  RULES: {
    CREATE: 'CreateNewRuleModal',
    INSPECT: 'RulesInspect',
    DUPLICATE: 'DuplicateRuleModal',
  },
  GROUPS: {
    CREATE: 'CreateRuleGroupOrRuleModal',
    INSPECT: 'GroupInspect',
  },
  ENTITIES: {
    CREATE: 'createNewEntityModal',
    INSPECT: 'EntityInspect',
  },
  CONTEXTS: {
    CREATE: 'createNewContextModal',
    INSPECT: 'ContextInspectForm',
  },
  DEPLOY: {
    UPLOAD: 'uploadProjectModal',
    UPLOAD_AND_DEPLOY: 'uploadAndDeployProjectModal',
  },
  INTENTS: {
    CREATE: 'createNewIntentModal',
    INSPECT: 'IntentInspect',
  },
  DICTIONARIES: {
    CREATE: 'createNewDictionaryModal',
    INSPECT: 'DictionaryInspectGeneral',
    UPLOAD_CSV: 'uploadCSVFileModal',
  },
  PROJECT: {
    NEW: 'NewProject',
    CLONE: 'CloneProject',
    IMPORT: 'ImportProject',
  },
  ENVIRONMENTS: {
    CREATE: 'CreateEnvironmentForm',
    TEST_CONNECTION: 'TestConnectionForm',
  },
  XPACK: {
    IMPORT: 'ImportXpackModal',
    UPDATE: 'UpdateXpackModal',
  },
  PASSWORD: {
    RESET: 'resetPasswordForm',
    UPDATE: 'updatePasswordForm',
    FORGOT: 'forgotPasswordForm',
  },
  USER: {
    LOGIN: 'loginForm',
    UPDATE: 'updateUserForm',
  },
  TEST_SETS: {
    CREATE: 'CreateTestSetTab',
    IMPORT: 'ImportTestSetTab',
    ADD_TO_DICTIONARY: 'AddWordToDictionary',
  },
  EDITOR: {
    GO_TO_LINE: 'GoToLineContent',
  },
  FILES: {
    UPLOAD: 'UploadFileModal',
  },
  NEW_FLOW: {
    DRAWER: 'drawer',
    RESOURCES: {
      CREATE: 'createNewResourceModal',
      TARGET: { DUPLICATE: 'duplicateTarget' },
    },
    APP_SETUP: {
      GENERAL: {
        INFORMATION: 'appsetupGeneralInformationForm',
        PROPERTIES: 'appsetupGeneralPropertiesForm',
      },
      FIELD: {
        CREATE: 'appsetupCreateFieldForm',
        UPDATE: 'appsetupUpdateFieldForm',
        CREATE_WITH_CATEGORY: 'appsetupCreateFieldWithCategoryForm',
      },
      REALIZERS: {
        CREATE: 'appSetupCreateRealizerForm',
        UPDATE: 'appSetupUpdateRealizerForm',
        CREATE_WITH_CATEGORY: 'appSetupCreateRealizerWithCategoryForm',
      },
      VALIDATIONS_AND_INFERENCES: {
        INFERENCE_CREATE: 'appSetupInferenceCreateForm',
        VALIDATION_CREATE: 'appSetupValidationCreateForm',
        INFERENCES: 'appSetupInferenceListForm',
        VALIDATIONS: 'appSetupValidationListForm',
      },
      GRAMMARS: {
        CREATE: 'appSetupCreateGrammarForm',
        UPDATE: 'appSetupUpdateGrammarForm',
        CREATE_WITH_CATEGORY: 'appSetupCreateGrammarWithCategoryForm',
      },
    },
  },
  VERSION_CONTROL: {
    ENABLE: 'enableVersionControlForm',
    COMMIT_PUSH: 'commitForm',
  },
};

export default formNames;
